import React from 'react'
import TabItem from './TabItem'
import { SelectionTabsProps } from './SelectionTabs.types'

const SelectionTabs: React.FC<SelectionTabsProps> = ({
  tabs,
  selectedTabs,
  onSelectTab,
  onClear,
}) => {
  return (
    <div className="flex flex-wrap gap-2 items-center">
      {tabs.map((tab) => (
        <TabItem
          key={tab.value}
          label={tab.label}
          active={selectedTabs.includes(tab.value)}
          onClick={() => onSelectTab(tab.value)}
        />
      ))}

      {/* Reset button only shows if more than 1 tab is selected */}
      {selectedTabs.length >= 1 && onClear && (
        <button
          type="button"
          onClick={onClear}
          className="px-4 h-10 rounded-md text-sm font-medium transition cursor-pointer bg-[var(--tab-bg)] border border-[var(--tab-btn-border)] text-[var(--tab-text)] hover:bg-[var(--bet-type-hover-bg)] hover:text-[var(--bet-type-hover-text)] hover:border-[var(--bet-type-hover-border)]"
        >
          ❌
        </button>
      )}
    </div>
  )
}

export default SelectionTabs
